import { WarningKey } from "@silo/types";
import { Banner } from "../banner";
import { Description } from "./description";

export interface BannerWarningProps {
  warningKey: WarningKey;
}

export function BannerWarning({ warningKey }: BannerWarningProps): JSX.Element {
  return (
    <Banner
      icon={
        <Banner.Icon className={Banner.icon({ className: "text-amber-300" })} />
      }
      content={<Description warningKey={warningKey} variant="banner" />}
    />
  );
}
